import { ValueOfKey } from '../../../utils-types';
import { SIDEBAR_ITEM_TYPE, PathType } from '../../constants/system/headerSettings';
import { NavigationIconType } from '../../constants/system/navigationIcons';
import { SolutionType } from '../../constants/user-info/solutionType';

export const SIDEBAR_BADGE_KEY = {
  UNREAD_MESSAGES: 'UNREAD_MESSAGES',
  SCAN_IQ_NEW_SCANS: 'SCAN_IQ_NEW_SCANS',
  NUTRITION_NEW_SCANS: 'NUTRITION_NEW_SCANS',
} as const;

export type SidebarBadgeKeyType = ValueOfKey<typeof SIDEBAR_BADGE_KEY>;

export type SidebarLinkItem = {
  label: string;
  icon: NavigationIconType | null;
  type: typeof SIDEBAR_ITEM_TYPE.LINK;
  badgeKey?: SidebarBadgeKeyType | null;
  path: string;
  pathType: PathType;
  items: [];
};

export type SidebarMenuItem = {
  label: string;
  icon: NavigationIconType | null;
  type: typeof SIDEBAR_ITEM_TYPE.MENU;
  badgeKey?: string | null;
  items: SidebarLinkItem[];
};

export type CollapseMenuItem = {
  label: string;
  icon: NavigationIconType | null;
  type: typeof SIDEBAR_ITEM_TYPE.COLLAPSE_MENU;
  items: SidebarLinkItem[];
};

export type GroupItem = {
  label?: string | null;
  type: typeof SIDEBAR_ITEM_TYPE.GROUP;
  items: (SidebarLinkItem | CollapseMenuItem | SidebarMenuItem)[];
};

export type SolutionItem = {
  label: string;
  icon: NavigationIconType | null;
  type: typeof SIDEBAR_ITEM_TYPE.SOLUTION;
  subType: SolutionType;
  items: GroupItem[];
};

export type MainNavItem = SidebarLinkItem | SolutionItem;

export type SystemMenuItem = SidebarLinkItem | SidebarMenuItem | CollapseMenuItem;

export type SideBarMenu = {
  mainNavigation: MainNavItem[];
  systemMenu: SystemMenuItem[];
};
